import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useEffect, useRef } from 'react';
import i18n from 'i18next';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';
import { TablePagination } from '@material-ui/core';
import DropDown from '../ui/react-ui/dropdown';
import DataTable from '../ui/table'; // api

import { getLogsTerminals } from '../../api/statsAPI'; // redux

import { setLogsTerminals, setLogsTerminalsSelected, setTerminalsSort, setLogsTerminalsCurrentPage, setLogsTerminalsRowPerPage, setLogsTerminalsTotal } from '../../redux/stats-dashboard';
var t = i18n.getFixedT(null, 'stats-dashboard');
var StatsDashboardTerminalsLog = /*#__PURE__*/React.memo(function (props) {
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot,
      _useSelector$statsDas = _useSelector.statsDashboard,
      logsTerminals = _useSelector$statsDas.logsTerminals,
      logsTerminalsSelected = _useSelector$statsDas.logsTerminalsSelected,
      dateTime = _useSelector$statsDas.dateTime,
      terminalsSort = _useSelector$statsDas.terminalsSort,
      logsTerminalsTotal = _useSelector$statsDas.logsTerminalsTotal,
      logsTerminalsCurrentPage = _useSelector$statsDas.logsTerminalsCurrentPage,
      logsTerminalsRowsPerPage = _useSelector$statsDas.logsTerminalsRowsPerPage,
      zonesList = _useSelector.app.zonesList;

  var dispatch = useDispatch();
  var isMounted = useRef(false);

  var handleSort = function handleSort(sort) {
    dispatch(setTerminalsSort(sort));
  };

  var handleChange = function handleChange(zoneId) {
    dispatch(setLogsTerminalsSelected(zoneId));
  };

  var handleChangePage = function handleChangePage(e, newPage) {
    dispatch(setLogsTerminalsCurrentPage(newPage));
  };

  var handleChangeRowsPerPage = function handleChangeRowsPerPage(e) {
    dispatch(setLogsTerminalsRowPerPage(parseInt(e.target.value, 10)));
    dispatch(setLogsTerminalsCurrentPage(0));
  };

  useEffect(function () {
    if (!isMounted.current) return;
    var offset = (Number(logsTerminalsCurrentPage + 1) - 1) * logsTerminalsRowsPerPage;
    getLogsTerminals(contextRoot, false, logsTerminalsSelected, dateTime, terminalsSort, offset, logsTerminalsRowsPerPage).then(function (result) {
      var newData = _.map(result.content, function (el, index) {
        return _objectSpread(_objectSpread({}, el), {}, {
          sequence: offset + index + 1
        });
      });

      dispatch(setLogsTerminals(newData));
      if (!_.isEqual(logsTerminalsTotal, result.totalElements)) dispatch(setLogsTerminalsTotal(result.totalElements));
    });
  }, [JSON.stringify(terminalsSort), logsTerminalsCurrentPage, logsTerminalsRowsPerPage, logsTerminalsSelected]);
  useEffect(function () {
    if (!isMounted.current) isMounted.current = true;
  }, []);
  var fields = {};

  _.set(fields, 'sequence', {
    label: t('lbl-sequence')
  });

  _.set(fields, 'terminalId', {
    label: t('lbl-terminal-station-id'),
    sortable: true
  });

  _.set(fields, 'terminalName', {
    label: t('lbl-terminal-station-name'),
    sortable: true
  });

  _.set(fields, 'trailerPlateNo', {
    label: t('lbl-trailerPlateNo'),
    sortable: true,
    formatter: function formatter(val, row) {
      return /*#__PURE__*/React.createElement("div", {
        className: "palteNo-div"
      }, val);
    }
  });

  _.set(fields, 'deliverType', {
    label: t('lbl-container-deliver-types'),
    sortable: true,
    formatter: function formatter(val, row) {
      return /*#__PURE__*/React.createElement("div", {
        className: "deliverType-div"
      }, val ? t('lbl-' + val.toUpperCase()) : '');
    }
  }); // _.set(fields, 'transportType', { label: t('lbl-transport-type'), sortable:true })


  _.set(fields, 'entryTime', {
    label: t('lbl-entry-time'),
    sortable: true
  });

  _.set(fields, 'exitTime', {
    label: t('lbl-exit-time'),
    sortable: true
  });

  _.set(fields, 'duration', {
    label: t('lbl-duration'),
    sortable: true,
    formatter: function formatter(val, row) {
      if (val === null) return '';
      return /*#__PURE__*/React.createElement("div", {
        className: "duration-div"
      }, val === -1 ? t('lbl-no-data') : val + t('lbl-minute'));
    }
  });

  return /*#__PURE__*/React.createElement("div", {
    className: "statsDashboard-log"
  }, /*#__PURE__*/React.createElement("div", {
    className: "log-head"
  }, /*#__PURE__*/React.createElement("span", {
    className: "log-title"
  }, t('lbl-terminals-log')), /*#__PURE__*/React.createElement("label", {
    className: "label"
  }, t('lbl-terminal-center'), ": "), /*#__PURE__*/React.createElement(DropDown, {
    defaultText: t('lbl-all-terminals-center'),
    list: zonesList,
    value: logsTerminalsSelected,
    onChange: handleChange
  })), /*#__PURE__*/React.createElement("div", {
    className: "c-border c-position-rlt"
  }, /*#__PURE__*/React.createElement(DataTable, {
    fields: fields,
    sort: terminalsSort,
    onSort: handleSort,
    data: logsTerminals
  })), /*#__PURE__*/React.createElement(TablePagination, {
    component: "div",
    labelRowsPerPage: t('lbl-per-page-row-count'),
    count: logsTerminalsTotal,
    page: logsTerminalsCurrentPage,
    onChangePage: handleChangePage,
    rowsPerPage: logsTerminalsRowsPerPage,
    onChangeRowsPerPage: handleChangeRowsPerPage
  }));
});
export default StatsDashboardTerminalsLog;